import React, {useState, useEffect,useReducer} from 'react'
import './css/QuizMenu.css'
import { AnimatePresence, motion } from 'framer-motion';
import AnimateHeight from 'react-animate-height';
//firebase stuff
import {firebase} from './firebase';
import {db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import AnswerScreen from './AnswerScreen';
import AnswerScreenVerbs from './AnswerScreenVerbs';
import { displayNounData,displayPhraseData,displayVerbData,displayVerbDataPast,getFirebaseData } from './displayQuizData';

//redux stuff
import { useSelector, useDispatch} from 'react-redux';

function VerbsDisplay(props) {


     const variants = {
          open: { opacity: 1, scale: 1.2 },
          closed: { opacity: 0, scale: 1  },
       }
     
     if(props.active == 'verbArea'){
          var selected = 'verb';
     }
     else{
          var selected = 'verbPAst';
     }

     return (

<div>
                                   <div className='textInputTitle'>

                                        {props.pastPresent == 'present' &&
                                             <p style = {{color: props.active == 'verbArea' ? "#fff" : "" }}>
                                             {props.pastPresent == 'present' ? "Test Your Verbs (present)" : "Test Your Verbs (past)" } 
                                             </p>
                                        }
                                        {props.pastPresent == 'past' &&
                                             <p style = {{color: props.active == 'verbAreaPast' ? "#fff" : "" }}>
                                             {props.pastPresent == 'present' ? "Test Your Verbs (present)" : "Test Your Verbs (past)" } 
                                             </p>
                                        }


                                   </div>

                                   <div className='quizLeft'>
                                        <div className='question'>{props.verbsAnswerObject.verb}</div>
                                   </div>

                                   <div className='quizRight'>
                                        <input type='text' value={props.verbsObject.infinitive} placeholder={ props.verbsMissing.infinitive ? "Enter a Value": "Infinitive" }
                                        className = { props.verbsMissing.infinitive ? 'textInputField pureVerb missing' : "textInputField pureVerb"}
                                             //onChange = {(event) => setVerbTranslation(event.target.value)} 
                                             onChange = {(event) => props.setVerbsObject(  {...props.verbsObject, infinitive:event.target.value } )}
                                              
                                             onFocus={ () => props.dispatch({type:'infinitive', payload:{infinitive:false}})} 
                                        />
                                   </div>
                                
                                   <div className='divide'></div>

                                   <div className='quizLeft'>
                                        <input type='text' value={props.verbsObject.I} placeholder={ props.verbsMissing.I ? "Enter a Value": "I" } 
                                        className = { props.verbsMissing.I ? 'textInputField missing' : "textInputField "}
                                             //onChange = {(event) => setVerbI(event.target.value)}
                                             onChange = {(event) => props.setVerbsObject(  {...props.verbsObject, I:event.target.value } )}
                                             onFocus={ () => props.dispatch({type:'I', payload:{I:false}})} 
                                        /> 

                                        <input type='text' value={props.verbsObject.you} placeholder={ props.verbsMissing.you ? "Enter a Value": "You" }
                                        className = { props.verbsMissing.you ? 'textInputField missing' : "textInputField "}
                                            //onChange = {(event) => setVerbYou(event.target.value)} 
                                             onChange = {(event) => props.setVerbsObject(  {...props.verbsObject, you:event.target.value } )}
                                             onFocus={ () => props.dispatch({type:'you', payload:{you:false}})} 
                                        />

                                        <input type='text' value={props.verbsObject.he} placeholder={ props.verbsMissing.he ? "Enter a Value": "He/She" }
                                        className = { props.verbsMissing.he ? 'textInputField missing' : "textInputField "}
                                             //onChange = {(event) => setVerbHe(event.target.value)} 
                                             onChange = {(event) => props.setVerbsObject(  {...props.verbsObject, he:event.target.value } )}
                                             onFocus={ () => props.dispatch({type:'he', payload:{he:false}})} 
                                        />

                                   </div>

                                   <div className='quizRight'>
                                        <input type='text' value={props.verbsObject.we} placeholder={ props.verbsMissing.we ? "Enter a Value": "We" }
                                        className = { props.verbsMissing.we ? 'textInputField missing' : "textInputField "}
                                             //onChange = {(event) => setVerbWe(event.target.value)} 
                                             onChange = {(event) => props.setVerbsObject(  {...props.verbsObject, we:event.target.value } )}
                                             onFocus={ () => props.dispatch({type:'we', payload:{we:false}})} 
                                        />

                                        <input type='text' value={props.verbsObject.yall} placeholder={ props.verbsMissing.yall ? "Enter a Value": "Y'all" }
                                        className = { props.verbsMissing.yall ? 'textInputField missing' : "textInputField "}
                                             //onChange = {(event) => setVerbYall(event.target.value)} 
                                             onChange = {(event) => props.setVerbsObject(  {...props.verbsObject, yall:event.target.value } )}
                                             onFocus={ () => props.dispatch({type:'yall', payload:{yall:false}})} 
                                        />

                                        <input type='text' value={props.verbsObject.they} placeholder={ props.verbsMissing.they ? "Enter a Value": "They" }
                                        className = { props.verbsMissing.they ? 'textInputField missing' : "textInputField "}
                                             //onChange = {(event) => setVerbThey(event.target.value)} 
                                             onChange = {(event) => props.setVerbsObject(  {...props.verbsObject, they:event.target.value } )}
                                             onFocus={ () => props.dispatch({type:'they', payload:{they:false}})} 
                                        />                                                                                
                                   </div>



</div>
          


)}

export default VerbsDisplay
